import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import hexToRgbaColor from './hexToRgbaColor';
var rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
/**
 * Calculates HEX color luminance
 */

function hexColorLuminance(hexColor) {
  var rgbaColor = hexToRgbaColor(hexColor);
  var rgbaMatched = rgbaRegex.exec(rgbaColor);

  if (!rgbaMatched) {
    throw new Error("Couldn't parse the RGBA color string.");
  } // Grab red, green, blue channels, since we don't need alpha


  var channels = [1, 2, 3].map(function (index) {
    return parseInt("".concat(rgbaMatched[index]), 10);
  });

  var _channels$map = channels.map(function (value) {
    var channel = value / 255;
    return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
  }),
      _channels$map2 = _slicedToArray(_channels$map, 3),
      r = _channels$map2[0],
      g = _channels$map2[1],
      b = _channels$map2[2];

  return parseFloat((0.2126 * r + 0.7152 * g + 0.0722 * b).toFixed(3));
}

export default hexColorLuminance;